import React from 'react';
import { css } from 'aphrodite/no-important';

import { clickTracking } from '../../utils/analytics';
import style from './styles';

export default ({ section, linkText }) => {
  const linkStyles = [
    style.a,
  ];

    return (
      <li className={ css(style.li) }>
        <a
          className={ css(linkStyles) }
          href={ `#${section}` }
          onClick={ () => { 
            clickTracking(section); 
          } }
        >
          { linkText }
        </a>
      </li>
    );
};



// WEBPACK FOOTER //
// ./src/components/NavigationListItem/index.js